<template>
  <!-- MENU -->
  <ul class="mainContain-navigation">
    <!-- TABLERO -->
    <li >
      <router-link to="/dashboard/indexV2" :class="{ active: option === 0 }">
        <figure>
          <span class="icon-Bistro-_Dashboard"></span>
        </figure>
      </router-link>
      <p>Tablero</p>
    </li>

    <!-- CONSOLIDADOPOS -->
    <li v-if="hasToShowPosTab">
      <router-link
        to="/dashboard/consolidatedPos"
        :class="{ active: option === 1 }"
      >
        <figure>
          <span class="icon-Bistro-_Comandas"></span>
        </figure>
      </router-link>
      <p>Consolidado</p>
    </li>

    <!-- CONSOLIDADO -->
    <li v-else>
      <router-link
        to="/dashboard/consolidatedV2"
        :class="{ active: option === 1 }"
      >
        <figure>
          <span class="icon-Bistro-_Comandas"></span>
        </figure>
      </router-link>
      <p>Consolidado</p>
    </li>

    <!-- FACTURACION -->
    <li>
      <router-link
        v-if="showBillingPage && hasToShowBillingPosTab"
        to="/dashboard/billingDetail"
        :class="{ active: option === 2 }"
      >
        <figure>
          <span class="icon-Bistro-_TDC"></span>
        </figure>
      </router-link>
      <p>Facturación</p>
    </li>

    <!-- REPORTES PDV-->
    <li v-if="hasToShowPosTab">
      <router-link
        to="/dashboard/reportPDV"
        :class="{ active: option === 3 }"
      >
        <figure>
          <span class="icon-Bistro-_FileDoble"></span>
        </figure>
      </router-link>
      <p>Reportes</p>
    </li>
    <!-- REPORTES -->
    <li v-else>
      <router-link
        to="/dashboard/report"
        :class="{ active: option === 3 }"
      >
        <figure>
          <span class="icon-Bistro-_FileDoble"></span>
        </figure>
      </router-link>
      <p>Reportes</p>
     
    </li>
    <!-- INTEGRACIONES -->
    <li v-if="hasToShowIntegrationsTab">
      <router-link
        to="/dashboard/integrations"
        :class="{ active: option === 4 }"
      >
        <figure>
          <span class="icon-Bistro-_Moto"></span>
        </figure>
      </router-link>
      <p>Gestor de delivery</p>

    </li>
    <!-- REPORTES BI -->
    <li v-if="hasToShowSupersetDashboard" class="menu-item-with-badge">
      <router-link
        to="/dashboard/reportesBI"
        :class="{ active: option === 5 }"
      >
        <figure>
          <span class="icon-Bistro-_FileDoble"></span>
          <badge type="new" />
        </figure>
      </router-link>
      <p>Reportes BI</p>

    </li>
  </ul>
</template>
<script>
import mixCommons from "../mixins/mixCommons";
import rolesCommons from "../mixins/rolesCommons";
import Badge from "@/components/BadgeComp";

export default {
  components: { Badge },
  mixins: [mixCommons, rolesCommons],
  data() {
    return {};
  },
  computed: {
    option() {
      return this.$store.getSideMenu;
    },
  },
  methods: {},
};
</script>

<style scoped>
.menu-item-with-badge figure {
  position: relative;
}
.menu-item-with-badge figure :deep(.badge) {
  position: absolute;
  top: -8px;
  right: -14px;
  transform: scale(0.75);
  transform-origin: top right;
}
</style>
